import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import { PageBar } from "../../CommonComponents";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
const base = "https://";

const Index = () => {
  const [employeeid, setEmployeeid] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGetFace = async () => {
    if (employeeid == "" || !employeeid) {
      toast.error("Employee ID is mandatory", { position: "top-right" });
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(
        base +
          "aqndg2bpjp7mnj7kowt42uxz240gknhz.lambda-url.ap-south-1.on.aws/save",
        {
          employee_id: employeeid,
        },
        {
          headers: {
            authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.status === "success") {
        setLoading(false);
        toast.success(
          response?.data?.body?.message || "Face has been added successfully",
          { position: "top-right" }
        );
      } else {
        setLoading(false);
        toast.error(
          response?.data?.body?.message ||
            "Something went wrong, Please try again later",
          { position: "top-right" }
        );
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      toast.error(
        "Please try again, if error persists please contact SSP Team",
        { position: "top-right" }
      );
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#EEF2F7",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" size={60} />
          <Typography
            variant="h6"
            sx={{ color: "#fff", mt: 2, fontWeight: 500 }}
          >
            Loading...
          </Typography>
        </Box>
      )}
      <PageBar text="Add Face" />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
          padding: "2rem",
          marginBottom: "1rem",
        }}
      >
        <TextField
          label="Enter Your Employee ID"
          variant="outlined"
          value={employeeid}
          onChange={(e) => setEmployeeid(e.target.value)}
          sx={{
            width: "100%",
            maxWidth: "400px",
            marginBottom: "1.5rem",
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#FFFFFF",
              "&:hover fieldset": {
                borderColor: "#1976D2",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1976D2",
              },
            },
            "& .MuiInputLabel-root": {
              color: "#666",
              "&.Mui-focused": {
                color: "#1976D2",
              },
            },
          }}
        />
        <Button
          variant="contained"
          sx={{
            width: "100%",
            maxWidth: "400px",
            padding: "0.75rem",
            borderRadius: "8px",
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: 600,
          }}
          style={{
            backgroundColor: "#1976D2",
          }}
          onClick={handleGetFace}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default Index;
